module.exports = __webpack_public_path__ + "static/media/home_btn.9838bd29.svg";